
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/auth/AuthContext';
import { SignupHeader } from '@/components/auth/SignupHeader';
import { SignupForm } from '@/components/auth/SignupForm';

const Signup: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Check if this is an email verification callback
  useEffect(() => {
    const hashParams = new URLSearchParams(location.hash.substring(1));
    const queryParams = new URLSearchParams(location.search);
    
    // Check for email verification tokens in URL (Supabase adds these after email verification)
    const hasAccessToken = hashParams.has('access_token') || queryParams.has('access_token');
    const type = hashParams.get('type') || queryParams.get('type');
    
    if (hasAccessToken && type === 'signup') {
      // User just verified their email, redirect to login with success message
      navigate('/login?verified=true', { replace: true });
      return;
    }
  }, [location, navigate]);

  // Redirect if already authenticated (but not from email verification)
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80')`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-white/90 to-primary/10" />
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-md space-y-8 p-4">
        <SignupHeader />
        <SignupForm />
      </div>
    </div>
  );
};

export default Signup;
